import { render, staticRenderFns } from "./changePasswordUser.vue?vue&type=template&id=6a6abd2e&"
import script from "./changePasswordUser.vue?vue&type=script&lang=js&"
export * from "./changePasswordUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports